module.exports = __webpack_public_path__ + "assets/12a0bb019419217cf3f748fc376f3507.png";